// src/components/PeoplePlan/configs/roleConfigs.js
export const ROLE_CONFIGS = {
  RESTAURANT_MANAGER: {
    key: 'RESTAURANT_MANAGER',
    apiEndpoint: '/api/restaurant-managers',
    displayName: 'Restaurant Managers',
    singularName: 'Restaurant Manager',
    oldTitle: 'RM',
    tableClass: 'restaurant-managers',
    sortable: false,
    columns: ['checkbox', 'name', 'tenure'],
  },
  ASSISTANT_MANAGER: {
    key: 'ASSISTANT_MANAGER',
    apiEndpoint: '/api/assistant-manager',
    displayName: 'Assistant Managers',
    singularName: 'Assistant Manager',
    oldTitle: 'AM',
    tableClass: 'assistant-managers',
    sortable: false,
    columns: ['checkbox', 'name', 'tenure'],
  },
  SHIFT_LEADER: {
    key: 'SHIFT_LEADER',
    apiEndpoint: '/api/shift-leaders',
    displayName: 'Shift Leaders',
    singularName: 'Shift Leader',
    oldTitle: 'SL',
    tableClass: 'shift-leaders',
    sortable: false,
    columns: ['checkbox', 'name', 'tenure'],
  },
  CREW_MEMBER: {
    key: 'CREW_MEMBER',
    apiEndpoint: '/api/crew-member',
    displayName: 'Crew Members',
    singularName: 'Crew Member',
    oldTitle: 'Crew Member',
    tableClass: 'crew-member',
    sortable: true,
    columns: ['checkbox', 'name', 'tenure'],
  },
};

// Helper function to get role config by key
export const getRoleConfig = (key) => {
  return ROLE_CONFIGS[key];
};

// Helper function to get role config by old title
export const getRoleConfigByTitle = (title) => {
  return Object.values(ROLE_CONFIGS).find(config => config.oldTitle === title);
};